import type { FaqEntity } from '@components/app/Faqs/buildFaqEntity'
import convertMarkdownToHtml from '@lib/utilities/text/convertMarkdownToHtml'
import type { ConjuredRagFaqWidget } from '..'

export function buildConjuredFaqEntity(faq: ConjuredRagFaqWidget): FaqEntity {
  const answerAsHtml = convertMarkdownToHtml(faq.content)

  return {
    '@type': 'Question',
    'acceptedAnswer': {
      '@type': 'Answer',
      'text': answerAsHtml,
    },
    'name': faq.simplifiedQuestion,
  }
}
